import { isCommercialSeller } from '../../config/r2rCommercialSeller';
import { hasPermissionToPostListings } from '../userHelpers';

/**
 * Whether this user may use listing import (CSV now; Shopify later).
 * Vendors (`commercial_non_sponsor`) and Community Sponsors (`commercial_sponsor`)
 * who can post listings. Hobbyists are excluded even when they can post.
 *
 * @param {Object|null|undefined} currentUser
 * @returns {boolean}
 */
export const canUseListingImport = currentUser =>
  hasPermissionToPostListings(currentUser) && isCommercialSeller(currentUser);
